import { defineStore } from 'pinia'

export const useAppStore = defineStore({
  id: 'app',
  state: () => ({
    isMobile: false,
    isTablet: false,
    sidebarMinimizedWidth: '',
    sidebarWidth: '',
    isSidebarMinimized: false,
    counters: {},
  }),
  getters: {
    counterByName: (state) => (name) => state.counters[name] || null,
    countersForMenu: (state) => (menuName, counterNames) => {
      if (!menuName && !(counterNames || []).length) return []

      let items = []
      if (Array.isArray(counterNames) && counterNames.length > 0) {
        items = counterNames
          .map((name) => state.counters[name])
          .filter(Boolean)
      } else {
        const prefix = `${menuName}_`
        items = Object.values(state.counters).filter(
          (counter) => counter.name === menuName || counter.name.startsWith(prefix),
        )
      }

      return items
        .filter((counter) => counter.value > 0)
        .sort((a, b) => {
          if (Array.isArray(counterNames) && counterNames.length > 0) {
            return counterNames.indexOf(a.name) - counterNames.indexOf(b.name)
          }
          return a.name.localeCompare(b.name)
        })
    },
  },
  actions: {
    setCounters(items) {
      const map = {}
      ;(items || []).forEach((item) => {
        if (!item?.name) return
        map[item.name] = {
          name: item.name,
          value: Number(item.value) || 0,
          color: item.color || '',
        }
      })
      this.counters = map
    },
    async loadCounters() {
      try {
        const items = await this.$api.edex.getCounters()
        this.setCounters(items)
      } catch (e) {
        console.log(e)
        this.counters = {}
      }
    },
  },
})
